<template>
  <div>
    <div style="float: right" class="text-xs-right">
      <v-btn
        icon
        @click="
          $emit('close')
          showPromotionItems = false
        "
      >
        <v-icon>close</v-icon></v-btn
      >
    </div>
    <div class="pa-5 pt-1">
      <v-layout row wrap>
        <v-flex xs12 sm5>
          <div
            style="position: relative; border: 1px solid grey; border-radius: 4px"
            class="showcarouselall"
          >
            <carousel
              v-if="ref_no_image.length"
              :mouse-drag="false"
              :touch-drag="false"
              :pull-drag="false"
              :items="1"
              :loop="true"
              :nav="false"
            >
              <div v-for="(item, k) in ref_no_image" :key="k" style="height: 360px; display: flex">
                <v-img contain :src="item" @click="showImage(item, ref_no_image, k)"></v-img>
              </div>

              <template slot="prev"
                ><v-btn
                  v-show="ref_no_image.length > 1"
                  style="
                    z-index: 2;
                    position: absolute;
                    left: 0px;
                    top: 50%;
                    transform: translate(0%, -50%);
                  "
                  icon
                  small
                  color="primary"
                  ><em class="fas fa-chevron-left" /></v-btn
              ></template>
              <template slot="next"
                ><v-btn
                  v-show="ref_no_image.length > 1"
                  style="
                    z-index: 2;
                    position: absolute;
                    right: 0px;
                    top: 50%;
                    transform: translate(0%, -50%);
                  "
                  icon
                  small
                  color="primary"
                  ><em class="fas fa-chevron-right" /></v-btn
              ></template>
            </carousel>
          </div>
        </v-flex>
        <v-flex xs12 sm7>
          <div class="pa-2 pl-3">
            <div>
              <span style="color: grey">ชื่อลูกค้า : </span> {{ editdata.customer_name }}
              <div
                class="mt-2 form-control"
                style="display: flex"
                :class="{ 'has-error': errors.has('ห้าง') }"
              >
                <div style="align-self: center" class="mr-4 pb-2">ห้าง:</div>
                <div v-if="isReadOnly">{{ input.department_store || '-' }}</div>
                <div v-else style="width: 70%">
                  <multiselect
                    v-model="input.department_store"
                    v-validate="'required'"
                    :data-vv-as="$t('ห้าง')"
                    name="ห้าง"
                    :options="departmentOptions"
                    @input="input.branch = ''"
                  ></multiselect>
                </div>
              </div>
              <div :class="{ 'has-error form-control': errors.has('ห้าง') }">
                <span v-if="errors.has('ห้าง')" class="text-error">{{ errors.first('ห้าง') }}</span>
              </div>
              <div class="mt-2" :class="{ 'has-error': errors.has('สาขา') }" style="display: flex">
                <div style="align-self: center" class="mr-4 pb-2">สาขา:</div>
                <div v-if="isReadOnly">{{ input.branch || '-' }}</div>
                <div v-else style="width: 70%">
                  <multiselect
                    v-model="input.branch"
                    v-validate="'required'"
                    :class="{ 'has-error': errors.has('สาขา') }"
                    :data-vv-as="$t('สาขา')"
                    name="สาขา"
                    :placeholder="
                      !input.department_store ? 'กรุณาเลือกห้างก่อนเลือกสาขา' : 'เลือกสาขา'
                    "
                    :disabled="!input.department_store"
                    :options="branchOptions"
                  >
                  </multiselect>
                </div>
              </div>
              <div :class="{ 'has-error form-control': errors.has('สาขา') }">
                <span v-if="errors.has('สาขา')" class="text-error">{{ errors.first('สาขา') }}</span>
              </div>
            </div>
          </div>
          <div>
            <v-divider class="my-3"></v-divider>
          </div>
          <div class="pl-3">
            <v-layout row wrap>
              <v-flex xs3> <div class="pt-3">เลขที่ใบเสร็จ :</div></v-flex>
              <v-flex xs9>
                <div v-if="isReadOnly" class="pt-3">{{ input.ref_no || '-' }}</div>
                <div
                  v-else
                  class="form-control pa-1"
                  style="position: relative"
                  :class="{ 'has-error': errors.has('เลขที่ใบเสร็จ'), 'is-valid': isRefnoValid }"
                >
                  <input
                    v-model="input.ref_no"
                    v-validate="
                      `required${approvetype === 'reject' ? '' : '|excludednew:' + excludedrefno}`
                    "
                    placeholder="กรอกเลขที่ใบเสร็จ"
                    :data-vv-as="$t('เลขที่ใบเสร็จ')"
                    name="เลขที่ใบเสร็จ"
                    class="form-control mb-0"
                    type="text"
                    @input="isRefnoValid = false"
                  />
                  <span v-if="errors.has('เลขที่ใบเสร็จ')" class="text-error">{{
                    errors.first('เลขที่ใบเสร็จ')
                  }}</span>
                  <div class="text-xs-right">
                    <v-btn
                      :loading="checkRefLoading"
                      color="primary"
                      :disabled="!checkAvailableRefButton"
                      @click="checkAvailableRef"
                      >ตรวจสอบ</v-btn
                    >
                  </div>
                </div>
              </v-flex>

              <v-flex xs3 class="pt-3">Ref. :</v-flex>
              <v-flex xs9>
                <div v-if="isReadOnly" class="pt-3">{{ input.ref || '-' }}</div>
                <div v-else class="form-control pa-1" :class="{ 'has-error': errors.has('Ref') }">
                  <input
                    v-model="input.ref"
                    placeholder="กรอก Ref"
                    :data-vv-as="$t('Ref')"
                    name="Ref"
                    class="form-control"
                    type="text"
                  />
                  <span v-if="errors.has('Ref')" class="text-error">{{ errors.first('Ref') }}</span>
                </div>
              </v-flex>
              <v-flex xs3 class="pt-3">วันที่ในเอกสาร :</v-flex>
              <v-flex xs9>
                <div v-if="isReadOnly" class="pt-3">
                  {{ input.date | DateFormat('DD/MM/YYYY') }}
                </div>
                <div
                  v-else
                  class="form-control pa-1"
                  :class="{ 'has-error': errors.has('วันที่ในเอกสาร') }"
                >
                  <DatePickerWithoutButton v-model="input.date" @input="errors.clear()">
                    <input
                      v-validate="'required'"
                      readonly
                      placeholder="กรอกวันที่ในเอกสาร"
                      :data-vv-as="$t('วันที่ในเอกสาร')"
                      name="วันที่ในเอกสาร"
                      :value="getDate(input.date)"
                      class="form-control"
                      type="text"
                    />
                  </DatePickerWithoutButton>
                  <span v-if="errors.has('วันที่ในเอกสาร')" class="text-error">{{
                    errors.first('วันที่ในเอกสาร')
                  }}</span>
                </div></v-flex
              >
            </v-layout>
          </div>
        </v-flex>
      </v-layout>

      <v-divider></v-divider>
      <div>
        <div class="my-3">
          <div style="font-weight: 600; font-size: 19px">
            {{ isReadOnly ? '' : 'กรอก' }}ข้อมูลสินค้า
          </div>
        </div>
        <div>
          <v-layout row wrap>
            <v-flex xs2>
              <div class="text-center">เลือกสินค้า (SKU)</div>
            </v-flex>
            <v-flex xs3>
              <div class="text-center">ชื่อสินค้า</div>
            </v-flex>

            <v-flex xs2> <div class="text-center">ราคา</div></v-flex>
            <v-flex xs2> <div class="text-center">จำนวน</div></v-flex>
            <v-flex xs2> <div class="text-center">รวมเงิน</div></v-flex>
            <v-flex xs1></v-flex>
            <v-flex xs12 class="pa-0 ma-0 pt-1">
              <div class="pa-2">
                <div v-for="(item, k) in products" :key="k">
                  <v-layout class="ma-0 pa-0">
                    <v-flex style="align-self: center" xs2>
                      <div v-if="isReadOnly">
                        {{ item.name.product_name }}
                      </div>
                      <div
                        v-else
                        class="form-control px-1"
                        :class="{ 'has-error': errors.has('สินค้า' + k) }"
                      >
                        <multiselect
                          :ref="'skuinput' + k"
                          v-model="item.name"
                          :custom-label="customProductsName"
                          placeholder="สินค้า"
                          :show-labels="false"
                          label="sku"
                          :options="allproducts"
                          :name="'สินค้า' + k"
                          :data-vv-as="$t('สินค้า')"
                          style="word-break: break-all"
                          @input="onChangeProduct(k, $event)"
                        ></multiselect>
                        <span v-if="errors.has('สินค้า' + k)" class="text-error">{{
                          errors.first('สินค้า' + k)
                        }}</span>
                      </div>
                    </v-flex>
                    <v-flex tabindex="-1" style="align-self: center" class="text-xs-center" xs3>{{
                      item.name.product_name
                    }}</v-flex>
                    <v-flex style="align-self: center" xs2 class="form-control">
                      <div v-if="isReadOnly" class="text-xs-center">
                        {{ numberFormat(item.price) }}
                      </div>
                      <div
                        v-else
                        class="form-control px-1"
                        :class="{ 'has-error': errors.has('ราคา' + k) }"
                      >
                        <input
                          v-model="item.price"
                          v-validate="'required'"
                          placeholder="ราคา"
                          :data-vv-as="$t('ราคา')"
                          :name="'ราคา' + k"
                          min="0"
                          class="form-control"
                          type="number"
                          @blur="!item.price ? (item.price = 0) : ''"
                          @keyup.enter="addmoreproduct"
                        />
                        <span v-if="errors.has('ราคา' + k)" class="text-error">
                          {{ errors.first('ราคา' + k) }}
                        </span>
                      </div>
                    </v-flex>
                    <v-flex style="align-self: center" xs2 class="form-control">
                      <div v-if="isReadOnly" class="text-xs-center">
                        {{ numberFormat(item.quantity) }}
                      </div>
                      <div
                        v-else
                        class="form-control px-1"
                        :class="{ 'has-error': errors.has('จำนวน' + k) }"
                      >
                        <input
                          v-model="item.quantity"
                          v-validate="'required'"
                          placeholder="จำนวน"
                          :data-vv-as="$t('จำนวน')"
                          :name="'จำนวน' + k"
                          class="form-control"
                          type="number"
                          @blur="!item.quantity || item.quantity == 0 ? (item.quantity = 1) : ''"
                          @keyup.enter="addmoreproduct"
                        />
                        <span v-if="errors.has('จำนวน' + k)" class="text-error">
                          {{ errors.first('จำนวน' + k) }}
                        </span>
                      </div>
                    </v-flex>
                    <v-flex xs2 style="align-self: center">
                      <div style="font-size: 17px" class="text-xs-center">
                        <span>
                          {{ numberFormat(item.quantity * item.price) }}
                        </span>
                      </div>
                    </v-flex>
                    <v-flex v-if="!isReadOnly" style="align-self: center" xs1 class="text-xs-right">
                      <v-btn v-if="isAvailableEdit" tabindex="-1" icon @click="deleteProducts(k)"
                        ><v-icon color="primary">delete</v-icon></v-btn
                      >
                    </v-flex>
                  </v-layout>
                </div>
                <v-divider class="my-2"></v-divider>
              </div>
              <div v-if="!isReadOnly" class="text-xs-right">
                <v-btn v-if="isAvailableEdit" flat color="primary" @click="addmoreproduct"
                  ><em class="mr-2 fas fa-plus" /> เพิ่มสินค้า</v-btn
                >
              </div>
            </v-flex>
            <v-flex xs12 class="py-3">
              <template v-if="showPromotionItems">
                <div class="primary--text">โปรโมชั่นที่เข้าร่วม</div>
                <div v-if="promotionItemList && promotionItemList.length > 0" class="pa-3">
                  <template v-for="(item, index) in promotionItemList">
                    <div
                      :key="index"
                      class="pa-3 mb-3"
                      style="border: 1px solid #ccc; border-radius: 4px"
                    >
                      <v-layout wrap>
                        <v-flex xs6 sm2 class="px-1">
                          <div class="primary--text">ชื่อโปรโมชั่น</div>
                          <div>{{ item.name }}</div>
                        </v-flex>
                        <v-flex xs6 sm2 class="px-1">
                          <div class="primary--text">ประเภทโปรโมชั่น</div>
                          <div>{{ item.promotion_type }}</div>
                        </v-flex>

                        <template v-if="item.promotion_type === 'ซื้อสินค้าครบ'">
                          <v-flex xs6 sm3 class="px-1">
                            <div class="primary--text">
                              {{ getItemCategory(item.full_purchase.type) }}
                            </div>
                            <div>
                              {{ getItemName(item.full_purchase, 'type', item.promotion_type) }}
                            </div>
                          </v-flex>
                          <v-flex xs6 sm3 class="px-1">
                            <div class="primary--text">
                              {{
                                item.full_purchase.price_type === 'item'
                                  ? 'ซื้อครบจำนวนชิ้น'
                                  : 'ซื้อมูลค่าตั้งแต่'
                              }}
                            </div>
                            <div>{{ item.full_purchase.price_from }}</div>
                          </v-flex>
                        </template>
                        <template v-else>
                          <v-flex xs6 sm3 class="px-1">
                            <div class="primary--text">
                              {{ getItemCategory(item.match.type_1) }}
                            </div>
                            <div>{{ getItemName(item.match, 'type_1', item.promotion_type) }}</div>
                          </v-flex>
                          <v-flex xs6 sm3 class="px-1">
                            <div class="primary--text">
                              {{ getItemCategory(item.match.type_2) }}
                            </div>
                            <div>{{ getItemName(item.match, 'type_2', item.promotion_type) }}</div>
                          </v-flex>
                        </template>

                        <v-flex xs6 sm2 class="px-1">
                          <div class="primary--text">คะแนนที่ได้รับ</div>
                          <div>{{ numberFormat(item.point_increase) }}</div>
                        </v-flex>
                      </v-layout>
                    </div>
                  </template>
                </div>
                <div
                  v-else
                  class="text-xs-center grey lighten-3 py-3 my-3"
                  style="border-radius: 10px"
                >
                  - ไม่มีรายการสินค้าโปรโมชั่น -
                </div>
              </template>
              <div class="text-xs-center pb-3">
                <v-btn
                  v-if="isAvailableEdit"
                  depressed
                  color="primary"
                  :disabled="!isAvailableCheckPromotion"
                  @click="handleCheckPromotion"
                  >เช็ครายการสินค้าโปรโมชั่น</v-btn
                >
                <div class="caption red--text pt-1">
                  <span v-if="input.branch && input.department_store">
                    * กดปุ่มเช็คโปรโมชันเพื่อให้ระบบสรุปคะแนนจากโปรโมชัน
                  </span>
                  <span v-else>* กรุณาเลือกห้าง และ สาขา เพื่อเช็คโปรโมชัน</span>
                </div>
              </div>
              <v-divider class="my-2"></v-divider>
            </v-flex>
          </v-layout>
        </div>
      </div>

      <div class="px-3">
        <v-layout row wrap>
          <v-flex xs7>
            <v-layout row wrap>
              <v-flex xs5 class="mt-1">คะแนนจากยอดซื้อ </v-flex>
              <v-flex xs7
                ><span class="mr-2" style="font-weight: 600; font-size: 19px">{{
                  numberFormat(points_by_purchase)
                }}</span>
                คะแนน
              </v-flex>
              <v-flex xs5 class="mt-1">คะแนนจากรายการสินค้า </v-flex>
              <v-flex xs7
                ><span class="mr-2" style="font-weight: 600; font-size: 19px">{{
                  numberFormat(points_by_product)
                }}</span>
                คะแนน
              </v-flex>
              <v-flex xs5 class="mt-1">คะแนนจากโปรโมชั่น </v-flex>
              <v-flex xs7
                ><span class="mr-2" style="font-weight: 600; font-size: 19px">{{
                  numberFormat(sumPromotionPoints)
                }}</span>
                คะแนน
              </v-flex>
              <v-flex xs5 class="mt-1">รวม </v-flex>
              <v-flex xs7
                ><span class="mr-2" style="font-weight: 600; font-size: 19px"
                  >{{
                    numberFormat(points_by_purchase + points_by_product + sumPromotionPoints)
                  }} </span
                >คะแนน
              </v-flex>
            </v-layout></v-flex
          >
          <v-flex xs5>
            <div style="font-size: 17px">
              รายการสินค้า
              <span class="primary--text text--weight-bold" style="font-weight: bold">{{
                products.length
              }}</span>
              รายการ

              <br />
              จำนวนทั้งหมด

              <span class="primary--text text--weight-bold" style="font-weight: bold"
                >{{ numberFormat(sumquantity) }}
              </span>
              รายการ
              <br />

              ยอดซื้อรวม
              <span class="primary--text font-weight-bold">{{ numberFormat(sumprice) }}</span> บาท
            </div>
          </v-flex>
        </v-layout>
      </div>

      <div
        v-if="
          editdata.accounting_status !== 'approved' && $store.state.privilege.role !== 'superadmin'
        "
        class="text-xs-center"
      >
        <div
          class="form-control text-xs-center"
          :class="{ 'has-error': errors.has('Approve / Reject') }"
        >
          <v-radio-group
            v-model="approvetype"
            v-validate="'required'"
            :error-messages="!approvetype ? errors.first('Approve / Reject') : ''"
            class="mb-0 pb-0"
            :name="'Approve / Reject'"
            :data-vv-as="$t('Approve / Reject')"
            style="justify-content: center !important"
            row
          >
            <v-radio color="green" value="approved">
              <template #label> <span class="green--text">Approve</span> </template>
            </v-radio>
            <v-radio color="red" value="reject">
              <template #label> <span class="red--text">Reject</span> </template></v-radio
            >
          </v-radio-group>
          <!-- <div>
            <span class="text-error" v-if="errors.has('Approve / Reject')">
              {{ errors.first('Approve / Reject') }}
            </span>
          </div> -->
        </div>
      </div>
      <div v-if="approvetype == 'reject'">
        <div class="form-control mb-2" :class="{ 'has-error': errors.has('topic_reject') }">
          <div style="display: flex; justify-content: center">
            <multiselect
              v-model="input.topic_reject"
              v-validate="'required'"
              :data-vv-as="'หัวข้อการ Reject'"
              name="topic_reject"
              :options="rejectOptions"
              style="width: 50%"
              placeholder="กรุณาเลือกหัวข้อการ Reject"
              :allow-empty="false"
              select-label
              selected-label
              deselect-label
            ></multiselect>
          </div>
          <div class="text-xs-center">
            <span v-if="errors.has('topic_reject')" class="text-error">
              {{ errors.first('topic_reject') }}
            </span>
          </div>
        </div>
        <div class="form-control text-xs-center" :class="{ 'has-error': errors.has('remark') }">
          <input
            v-model="input.remark"
            style="width: 50%"
            placeholder="กรอกสาเหตุที่ Reject"
            :name="'remark'"
            class="form-control"
            type="text"
          />
          <div>
            <span v-if="errors.has('remark')" class="text-error">
              {{ errors.first('remark') }}
            </span>
          </div>
        </div>
      </div>
      <div v-if="isAvailableEdit" class="text-xs-center mt-2">
        <v-btn :loading="saveloading" depressed color="primary" @click="saveData">ยืนยัน</v-btn>
        <v-btn color="grey" outline @click="$emit('close')">ยกเลิก</v-btn>
      </div>
    </div>
    <v-dialog v-model="showImageDialog" width="550px" persistent>
      <v-card v-if="showImageDialog">
        <div class="text-xs-right">
          <v-btn icon @click="showImageDialog = false"> <v-icon>close</v-icon></v-btn>
        </div>
        <img style="object-fit: contain; width: 100%" :src="currentShowImage" />
        <div class="pa-3"></div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import carousel from 'vue-owl-carousel'
import Multiselect from 'vue-multiselect'
import DatePickerWithoutButton from '@/components/elements/DatePickerWithoutButton.vue'
import moment from 'moment'
import api from '@/api'
import { mapGetters } from 'vuex'
import CurrencyInput from '@/components/elements/CurrencyInput.vue'
import PhotoViewer from 'photoviewer'
import toaCrmApi from '@/api/toa-crm'

export default {
  components: {
    carousel,
    Multiselect,
    DatePickerWithoutButton,
    CurrencyInput
  },
  props: ['editdata', 'readonly', 'alldata'],
  data() {
    return {
      checkRefLoading: false,
      isRefnoValid: false,
      excludedrefno: '',
      excludedsku: '',
      currentShowImage: '',
      showImageDialog: false,
      ref_no_image: [],
      saveloading: false,
      approvetype: '',
      input: {
        branch: '',
        department_store: '',
        ref_no: '',
        ref: '',
        date: '',
        topic_reject: '',
        remark: ''
      },
      products: [
        {
          name: '',
          price: 0,
          quantity: 0,
          total: 0
        }
      ],
      rejectOptions: ['ลูกค้าแนบใบเสร็จมาไม่ครบ', 'อื่นๆ'],
      promotionItems: [],
      showPromotionItems: false
    }
  },
  computed: {
    isReadOnly() {
      let tempReadOnly = false
      if (this.readonly) {
        tempReadOnly = true
      } else if (
        this.$store.state.privilege &&
        this.$store.state.privilege.role === 'admin' &&
        this.editdata.status === 'approved'
      ) {
        tempReadOnly = true
      }
      return tempReadOnly
    },
    checkAvailableRefButton() {
      return this.input.branch && this.input.department_store && this.input.ref_no
    },
    ...mapGetters(['selectedBot']),
    isAvailableCheckPromotion() {
      if (this.input.branch && this.input.department_store) {
        if (this.products[0].name && this.products[0].price > 0 && this.products[0].quantity > 0) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    promotionItemList() {
      const promotionItems = this.promotionItems
      let tempData = []
      if (promotionItems && promotionItems.length > 0) {
        promotionItems.forEach((el) => {
          const promotionItemId = el.match
            ? `match_${el.match.id}`
            : `full_purchase_${el.full_purchase.id}`
          const data = {
            id: el.id,
            name: el.name,
            promotion_type: el.promotion_type,
            promotion_item_id: promotionItemId,
            match: el.match,
            full_purchase: el.full_purchase,
            point_increase: el.point_increase
          }

          if (!tempData.some((item) => item.id === el.id)) {
            tempData.push(data)
          } else {
            if (!tempData.some((item) => item.promotion_item_id === promotionItemId)) {
              tempData.push(data)
            } else {
              const objIndex = tempData.findIndex((obj) => obj.promotion_item_id == promotionItemId)
              const currentpoint = tempData[objIndex].point_increase
              tempData[objIndex].point_increase =
                parseFloat(currentpoint) + parseFloat(el.point_increase)
            }
          }
        })
      }

      return tempData
    },
    sumPromotionPoints() {
      return Math.floor(
        parseFloat(
          this.promotionItemList.reduce((acc, cur) => {
            return acc + parseFloat(cur.point_increase || 0)
          }, 0)
        )
      )
    },
    formattedProduct() {
      let products = []
      this.products.forEach((el) => {
        const pointByProduct = this.calculatePointByProduct(el.name, el.quantity)
        const pointByPurchase = this.calculatePointByPurchase(el.price, el.quantity)
        const totalPoints = pointByProduct + pointByPurchase
        const pointPerItem = parseFloat(totalPoints || 0) / parseFloat(el.quantity || 0)
        products.push({
          name: el.name,
          price: el.price,
          quantity: el.quantity,
          point_per_item: pointPerItem,
          total_point: totalPoints
        })
      })

      return products
    },
    sumquantity() {
      return Math.floor(
        this.products.reduce((acc, cur) => {
          return acc + parseFloat(cur.quantity || 0)
        }, 0)
      )
    },
    sumprice() {
      return Math.floor(
        parseFloat(
          this.products.reduce((acc, cur) => {
            return acc + parseFloat(cur.price || 0) * parseFloat(cur.quantity)
          }, 0)
        )
      )
    },
    points_by_purchase() {
      var result = 0
      var sum = this.products.reduce((acc, cur) => {
        return acc + parseFloat(cur.price || 0) * parseFloat(cur.quantity || 0)
      }, 0)
      result = sum / this.purchase_amount
      return Math.floor(result)
    },
    points_by_product() {
      var result
      result = this.products.reduce((acc, cur) => {
        return (
          acc + (cur.name ? parseFloat(cur.name.points || 0) : 0) * parseFloat(cur.quantity || 0)
        )
      }, 0)
      return Math.floor(result)
    },
    purchase_amount() {
      if (this.$store.state.toacrmpointdata && this.$store.state.toacrmpointdata.purchase_amount) {
        return Math.floor(parseFloat(this.$store.state.toacrmpointdata.purchase_amount))
      } else return 0
    },
    allproducts() {
      var localsku = this.products.map((el) => {
        return el.name.sku
      })

      var result = this.$store.state.toacrmproducts.filter((el) => {
        if (!this.input.department_store) {
          return true
        } else {
          return el.department_store == this.input.department_store
        }
      })

      result = result.map((el) => {
        return {
          ...el,
          $isDisabled: [...localsku, ...this.excludedsku].includes(el.sku)
        }
      })
      return result
    },
    departmentOptions() {
      var departments = [
        ...new Set(this.$store.state.toacrmbranch.map((el) => el.department_store))
      ]

      return departments
    },
    branchOptions() {
      if (this.input.department_store) {
        var departments = this.$store.state.toacrmbranch
          .filter((el) => el.department_store == this.input.department_store)
          .map((el) => el.branch)
        return departments
      } else return []
    },
    isAvailableEdit() {
      return (
        this.editdata.accounting_status !== 'approved' ||
        (this.$store.state.privilege && this.$store.state.privilege.role === 'superadmin')
      )
    }
  },
  mounted() {
    window.scrollTo(0, 0)

    try {
      const attachments = JSON.parse(this.editdata.ref_no_image)
      this.ref_no_image = attachments ? attachments.filter((attachment) => attachment) : []
    } catch (error) {
      console.error(error)
      this.ref_no_image = []
    }
    this.input.department_store = this.editdata.department_store
    this.input.branch = this.editdata.branch
    this.input.ref_no = this.editdata.ref_no
    this.input.date = moment(this.editdata.timestamp).format('YYYY-MM-DD')
    this.input.ref = this.editdata.details.ref
    if (this.editdata.details) {
      this.products = this.editdata.details.products
      if (this.editdata.details.date) {
        this.input.date = this.editdata.details.date
      }
    }

    if (this.editdata.promotion) {
      this.promotionItems = this.editdata.promotion.data
      this.showPromotionItems = true
    }
    var allotherdata = this.alldata.filter((el) => {
      return (
        el.id !== this.editdata.id &&
        el.department_store === this.editdata.department_store &&
        el.branch === this.editdata.branch
      )
    })
    this.excludedrefno = allotherdata.map((el) => el.ref_no).join(',')
    this.excludedsku = allotherdata.map((el) => el.details.products.map((val) => val.name.sku))
    this.excludedsku = [].concat.apply([], this.excludedsku)
  },
  methods: {
    showImage(item, images, k) {
      var items = images.map((el, index) => {
        return {
          src: el,
          title: `${index + 1}/${images.length}`
        }
      })

      // define options (if needed)
      var options = {
        fixedContent: false,
        fixedModalPos: true,
        index: k // this option means you will start at first image
      }

      // Initialize the plugin
      var viewer = new PhotoViewer(items, options)
      document.querySelector('.photoviewer-modal').addEventListener(
        'click',
        function (event) {
          //  document.getElementById("output-box").innerHTML += "Sorry! <code>preventDefault()</code> won't let you check this!<br>";
          event.preventDefault()
        },
        false
      )
    },
    checkAvailableRef() {
      var data = {
        pageid: this.selectedBot.pageid,
        id: this.editdata.id, // id ของรายการ
        refNo: this.input.ref_no, // เลขที่ใบเสร็จ
        departmentStore: this.input.department_store, // ห้าง
        branch: this.input.branch // สาขา
      }
      this.checkRefLoading = true
      api.getToacrmCheckAvailableRef(data, async (err, response) => {
        this.checkRefLoading = false
        if (response.responsecode == 200) {
          this.isRefnoValid = true
        } else {
          await this.$swal.fire({
            text: 'เลขที่ใบเสร็จนี้ ถูกใช้แล้ว'
          })
          this.isRefnoValid = false
        }
      })
    },
    async saveData() {
      if (await this.$validator.validateAll()) {
        this.saveloading = true
        if (['superadmin'].includes(this.$store.state.privilege.role)) {
          await this.superadminSave()
        } else if (['admin'].includes(this.$store.state.privilege.role)) {
          await this.adminSave()
        } else if (['manager'].includes(this.$store.state.privilege.role)) {
          await this.managerSave()
        } else if (['accounting'].includes(this.$store.state.privilege.role)) {
          await this.accountingSave()
        }

        this.saveloading = false
      }
    },
    async superadminSave() {
      const vm = this
      try {
        const data = {
          page_id: vm.selectedBot.pageid,
          id: vm.editdata.id, // id ของรายการสะสมแต้ม
          details: {
            ref_no: vm.input.ref_no,
            ref: vm.input.ref,
            date: vm.input.date,
            products: vm.formattedProduct
          }, // ไม่ต้อง stringify
          department_store: this.input.department_store,
          branch: this.input.branch,
          points_by_purchase: vm.points_by_purchase, // points รวมที่ได้จากยอดซื้อทั้งหมด
          points_by_product: vm.points_by_product, // points รวมที่ได้จากรายการสินค้าทั้งหมด
          total_points: vm.points_by_purchase + vm.points_by_product // คะแนนรวม points ทั้งหมด
        }

        vm.saveloading = true
        const response = await toaCrmApi.postSuperadminUpdateRewardPoint({ data: data })
        vm.saveloading = false

        if (response && response.status === 200) {
          await vm.$swal.fire({
            type: 'success',
            text: 'สำเร็จ'
          })
          vm.$emit('onsave')
        }
      } catch (error) {
        console.error(error)
        vm.saveloading = false
      }
    },
    adminSave() {
      return new Promise((resolve) => {
        let data = {
          pageid: this.selectedBot.pageid,
          id: this.editdata.id, // id ของรายการสะสมแต้ม
          status: this.approvetype, // approved หรือ reject
          details: {
            ref_no: this.input.ref_no,
            ref: this.input.ref,
            date: this.input.date,
            products: this.formattedProduct
          }, // ไม่ต้อง stringify
          department_store: this.input.department_store,
          branch: this.input.branch,
          points_by_purchase: this.points_by_purchase, // points รวมที่ได้จากยอดซื้อทั้งหมด
          points_by_product: this.points_by_product, // points รวมที่ได้จากรายการสินค้าทั้งหมด
          total_points: this.points_by_purchase + this.points_by_product // คะแนนรวม points ทั้งหมด
        }

        if (this.approvetype == 'reject') {
          Object.assign(data, {
            admin_topic_remark:
              this.input.topic_reject === 'ลูกค้าแนบใบเสร็จมาไม่ครบ'
                ? 'แนบใบเสร็จมาไม่ครบ'
                : this.input.topic_reject,
            remark: this.input.remark
          })
        }

        api.Adminapprovereceipttoacrm(data, async (err, response) => {
          this.saveloading = false
          if (response.responsecode == 200) {
            await this.$swal.fire({
              type: 'success',
              text: 'สำเร็จ'
            })
            this.$emit('onsave')
          }
          resolve()
        })
      })
    },
    managerSave() {
      return new Promise((resolve) => {
        var data = {
          pageid: this.selectedBot.pageid,
          rewardid_list: [this.editdata.id],
          manager_status: this.approvetype, // approved หรือ reject

          ...(this.approvetype == 'reject' ? { remark: this.input.remark } : {}) // ส่งมาเฉพาะถ้า status > reject
        }

        api.Managerapprovereceipttoacrm(data, async (err, response) => {
          this.saveloading = false
          if (response.responsecode == 200) {
            await this.$swal.fire({
              type: 'success',
              text: 'สำเร็จ'
            })
            this.$emit('onsave')
          }
          resolve()
        })
      })
    },
    accountingSave() {
      return new Promise((resolve) => {
        var data = {
          pageid: this.selectedBot.pageid,
          rewardid_list: [this.editdata.id],
          accounting_status: this.approvetype, // approved หรือ reject

          ...(this.approvetype == 'reject' ? { remark: this.input.remark } : {}) // ส่งมาเฉพาะถ้า status > reject
        }

        api.Accountingapprovereceipttoacrm(data, async (err, response) => {
          this.saveloading = false
          if (response.responsecode == 200) {
            await this.$swal.fire({
              type: 'success',
              text: 'สำเร็จ'
            })
            this.$emit('onsave')
          }
          resolve()
        })
      })
    },
    customProductsName(val) {
      return val.sku
    },
    deleteProducts(k) {
      this.products.splice(k, 1)
      this.errors.clear()
    },
    addmoreproduct() {
      this.products.push({
        name: '',
        price: 0,
        quantity: 1,
        total: 0
      })
      this.$nextTick(() => {
        const skuref = this.$refs['skuinput' + (this.products.length - 1)]
        skuref[0].$el.focus()
      })
    },
    onChangeProduct(k, e) {
      this.products[k].price = e.price
    },
    getDate(val) {
      if (val) return moment(val).format('DD/MM/YYYY')
      else return ''
    },
    calculatePointByPurchase(price, qty) {
      try {
        const total = parseFloat(price || 0) * parseFloat(qty || 0)
        const result = total / this.purchase_amount
        return Math.floor(result)
      } catch (error) {
        console.error(error)
      }
    },
    calculatePointByProduct(product, qty) {
      try {
        const result = parseFloat(product.points || 0) * parseFloat(qty || 0)
        return Math.floor(result)
      } catch (error) {
        console.error(error)
      }
    },
    async handleCheckPromotion() {
      const vm = this
      try {
        const data = {
          department_store: vm.input.department_store,
          branch: vm.input.branch,
          products: vm.formattedProduct,
          date: vm.input.date
        }

        vm.$store.dispatch('loading')
        const response = await vm.checkPromotion(data)
        vm.$store.dispatch('loading')

        if (response && response.status === 200) {
          vm.showPromotionItems = true
          vm.promotionItems = response.data.data
        }
      } catch (error) {
        console.error(error)
      }
    },
    async checkPromotion(data) {
      const vm = this
      try {
        const response = await toaCrmApi.postCheckPromotion({
          data: data,
          pageId: vm.selectedBot.pageid
        })

        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
        return null
      }
    },
    getItemCategory(type) {
      if (type === 'product') {
        return 'สินค้า'
      } else if (type === 'mkt') {
        return 'Marketing'
      } else {
        return 'Sub Marketing'
      }
    },
    getItemName(item, column = null, promotionType) {
      let name = ''
      if (item) {
        if (promotionType === 'ซื้อสินค้าครบ') {
          switch (item.type) {
            case 'product':
              name = item.product_id
              break
            case 'mkt':
              name = item.mkt_id
              break
            case 'submkt':
              name = item.sub_mkt_id
              break

            default:
              break
          }
        } else {
          const type = column === 'type_1' ? item.type_1 : item.type_2
          switch (type) {
            case 'product':
              name = column === 'type_1' ? item.product_id_1 : item.product_id_2
              break
            case 'mkt':
              name = column === 'type_1' ? item.mkt_id_1 : item.mkt_id_2
              break
            case 'submkt':
              name = column === 'type_1' ? item.sub_mkt_id_1 : item.sub_mkt_id_2
              break

            default:
              break
          }
        }
      }

      return name
    }
  }
}
</script>

<style lang="scss">
.showcarouselall div span {
  /* Your style */
  display: block !important;
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/toacrm/ApproveReceiptEdit.vue